import { useQuery } from '@tanstack/react-query';

import axios from 'axios';
import { ExtractFnReturnType, QueryConfig } from 'lib/react-query';

import { Location } from 'types';

export const getLocations = async (): Promise<Location[]> => {
  const { data }: { data: Location[] } = await axios.get(`/api/locations`);
  return data as Location[];
};

type QueryFnType = typeof getLocations;

type UseLocationsOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const useLocations = ({ config }: UseLocationsOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['locations'],
    queryFn: () => getLocations(),
    ...config,
  });
};

const removeDisabledLocations = (locations: Location[]) =>
  locations.filter((item) => !!item.enabled);

export const useEnabledLocations = ({ config }: UseLocationsOptions) =>
  useLocations({
    config: {
      ...config,
      select: removeDisabledLocations,
    },
  });
